export const SEARCH_RESTAURANTS = "SEARCH_RESTAURANTS";
export const SEARCH_ITEMS = "SEARCH_ITEMS";
export const CLEAR_SEARCH = "CLEAR_SEARCH";
export const CLEAR_ITEM_SEARCH = "CLEAR_ITEM_SEARCH";
export const SAVE_SEARCH_QUERY = "SAVE_SEARCH_QUERY";
export const SAVE_SELECTED_FILTER = "SAVE_SELECTED_FILTER";
export const SAVE_SEARCH_MODE = "SAVE_SEARCH_MODE";
export const SAVE_SCROLL_POSITION = "SAVE_SCROLL_POSITION";
export const SAVE_FILTER_SCROLL_POSITION = "SAVE_FILTER_SCROLL_POSITION";
